import React, { useState } from 'react';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogBody,
  DialogFooter,
} from '../../../../../components/ui/Dialog';
import { Button } from '../../../../../components/ui/Button';
import EtapeForm from '../forms/EtapeForm';
import { copyEtape } from '../../../projectService';

const EtapeModal = ({
  visible,
  onClose,
  submitForm,
  formProps,
  error = null,
  title,
}: {
  visible?: any;
  onClose?: any;
  submitForm?: any;
  formProps?: any;
  error?: any;
  title?: any;
  data?: any;
}) => {
  const [submit, setSubmit] = useState(false);

  const formSubmit = (values) => {
    setSubmit(false);
    submitForm(values);
  };

  return (
    <Dialog open={visible} onOpenChange={onClose}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>{title}</DialogTitle>
        </DialogHeader>
        <DialogBody>
          <EtapeForm formProps={formProps} submit={formSubmit} submitOutside={submit} />
        </DialogBody>
        <DialogFooter>
          <Button
            key={1}
            variant="outline"
            data-testid="etape-modal-close-btn"
            onClick={() => onClose()}
          >
            Zavřít
          </Button>
          {formProps?.is_owned_by_my_company ? (
            <>
              <Button
                key={2}
                variant="outline"
                data-testid="etape-modal-copy-btn"
                onClick={async () => {
                  try {
                    await copyEtape(formProps?.id);
                    onClose({ withReset: true });
                  } catch (err) {
                    console.error(err);
                  }
                }}
              >
                Vytvořit kopii
              </Button>
              <Button key={3} data-testid="etape-modal-submit-btn" onClick={() => setSubmit(true)}>
                Potvrdit
              </Button>
            </>
          ) : (
            <Button
              key={2}
              variant="outline"
              data-testid="etape-modal-request-phase-btn"
              onClick={async () => {
                try {
                  await copyEtape(formProps?.id);
                } catch (err) {
                  console.error(err);
                }
              }}
            >
              Požádat o novou fázi
            </Button>
          )}
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default EtapeModal;
